import { empApi } from "./client";

// =============================================================
// API Phê duyệt chấm công ngoài (quản lý) - FEv1 cổng nhân viên.
// Khớp endpoint app (backend-v1). Phạm vi do BE lọc theo token.
// Trạng thái dạng chuỗi: PENDING | APPROVED | REJECTED.
// =============================================================

// Danh sách đăng ký chấm công ngoài (quản lý) -> { items, pagination }
export const getOutsideListApi = (params) =>
  empApi.get("/registerCheckIn/app", params);

// Chi tiết một đăng ký
export const getOutsideDetailApi = (id) =>
  empApi.get(`/registerCheckIn/app/detail/${id}`);

// Duyệt ("APPROVED") / từ chối ("REJECTED")
export const approveOutsideApi = (id, status) =>
  empApi.put(`/registerCheckIn/app/approve/${id}`, { status });
